import React from 'react';
import { useAppContext } from "../../useAppState";
import { Link, useLocation } from "react-router-dom";
import { Modal, Button } from 'react-bootstrap';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import 'moment/min/locales'
import 'moment-timezone';
import certificateIcon from '../../images/certificate-icon.png';


const CertificateDisplay = ({ currentCertificateData, showModal, handleClose, dateEarned }) => {

    const { state, actions } = useAppContext();
    const location = useLocation();

    // Timezone utility function
    const momentInUserTimezone = (date) => {
        return moment(date).tz(state.userInfos.timezone);
    };

    if (!currentCertificateData) return null;

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = `data:application/pdf;base64,${currentCertificateData.pdf}`;

        const normalizedDate = momentInUserTimezone(currentCertificateData.dateEarned).format('YYYY-MM-DD');
        link.download = `certificate_${normalizedDate}.pdf`;
        link.click();
    };

    console.log('currentCertificateData', currentCertificateData);

    const provinceMapping = {
        'AB': state.lang === 'fr' ? 'Alberta' : 'Alberta',
        'BC': state.lang === 'fr' ? 'Colombie-Britannique' : 'British Columbia',
        'MB': state.lang === 'fr' ? 'Manitoba' : 'Manitoba',
        'NB': state.lang === 'fr' ? 'Nouveau-Brunswick' : 'New Brunswick',
        'NL': state.lang === 'fr' ? 'Terre-Neuve-et-Labrador' : 'Newfoundland and Labrador',
        'NS': state.lang === 'fr' ? 'Nouvelle-Écosse' : 'Nova Scotia',
        'ON': state.lang === 'fr' ? 'Ontario' : 'Ontario',
        'PE': state.lang === 'fr' ? 'Île-du-Prince-Édouard' : 'Prince Edward Island',
        'QC': state.lang === 'fr' ? 'Québec' : 'Quebec',
        'SK': state.lang === 'fr' ? 'Saskatchewan' : 'Saskatchewan',
        'NT': state.lang === 'fr' ? 'Territoires du Nord-Ouest' : 'Northwest Territories',
        'NU': state.lang === 'fr' ? 'Nunavut' : 'Nunavut',
        'YT': state.lang === 'fr' ? 'Yukon' : 'Yukon',
    };

    return (
        <Modal show={showModal} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{state.lang === 'fr' ? 'Certificat obtenu' : 'Certificate earned'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                {
                    currentCertificateData.configurationProvinces && currentCertificateData.configurationProvinces.length > 0 && (
                        <div className="certificate-provinces" style={{ margin: '0 0 25px 0' }}>
                            {state.lang === 'fr' ? 'Accredité' : 'Accredited'}: &nbsp;
                            {JSON.parse(currentCertificateData.configurationProvinces).map((province, index) => (
                                <span
                                    key={index}
                                    className="badge badge-secondary badge-pill"
                                    style={{ margin: '0 10px 0 0' }} >
                                    {provinceMapping[province]}
                                </span>
                            ))}
                        </div>
                    )
                }
                {currentCertificateData.pdf && (
                    <Worker workerUrl="/pdf.worker.min.js">
                        <Viewer fileUrl={`data:application/pdf;base64,${currentCertificateData.pdf}`} />
                    </Worker>
                )}
            </Modal.Body>
            <Modal.Footer style={location.pathname !== '/all-certificates' ? { display: 'flex', justifyContent: 'space-between' } : {}}>
                {
                    location.pathname !== '/all-certificates' && (
                        <Link to={'/all-certificates'}>
                            <Button variant="secondary">
                                {state.lang === 'fr' ? 'Voir tous mes certificats' : 'View all my certificates'}
                                <img
                                    src={certificateIcon}
                                    alt="certificate-icon"
                                    style={{ width: 20, margin: '0 0 0 10px' }} />
                            </Button>
                        </Link>
                    )
                }


                <Button variant="primary" onClick={handleDownload}>
                    {state.lang === 'fr' ? 'Télécharger le certificat' : 'Download certificate'} <FontAwesomeIcon icon={faDownload} />
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CertificateDisplay;